<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form @submit="createContrat" :validation-schema="contratSchema">
        <div class="row">
          <!-- Sélection de l'emplacement -->
          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="codeemp" class="form-label fw-medium text-black">
                Emplacement <span class="text-danger">*</span>
              </label>
              <Field name="codeemp" v-model="codeemp" class="form-control shadow-none fs-md-15 text-black"
                v-slot="{ field }">
                <Multiselect v-model="field.value" v-bind="field" :filter-results="false" :min-chars="2"
                  :resolve-on-load="false" :delay="0" :searchable="true" :options-limit="300" :options="async (query) => {
                    if (query && query.length >= 2) {

                      const results = await fetchEmplacementOptions(query);
                      if (results && results.length > 0) {
                        return results;
                      } else {
                        return [
                          { value: '', label: 'Aucun emplacement trouvé' },
                        ];
                      }
                    } else {
                      return [];
                    }
                  }
                    " noOptionsText="Tapez au moins deux caractères" placeholder="Rechercher un emplacement" />
              </Field>
              <ErrorMessage name="codeemp" class="text-danger" />
            </div>
          </div>

          <!-- Sélection de l'usager -->
          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="matricule" class="form-label fw-medium text-black">
                Usager <span class="text-danger">*</span>
              </label>
              <Field name="matricule" v-model="matricule" class="form-control shadow-none fs-md-15 text-black"
                v-slot="{ field }">
                <Multiselect v-model="field.value" v-bind="field" :filter-results="false" :min-chars="2"
                  :resolve-on-load="false" :delay="0" :searchable="true" :options-limit="300" :options="async (query) => {
                    if (query && query.length >= 2) {
                      const results = await fetchUsagerOptions(query);
                      if (results && results.length > 0) {
                        return results;
                      } else {
                        return [
                          { value: '', label: 'Aucun usager trouvé' },
                        ];
                      }
                    } else {
                      return [];
                    }
                  }
                    " noOptionsText="Tapez au moins deux caractères" placeholder="Rechercher un usager" />
              </Field>
              <ErrorMessage name="matricule" class="text-danger" />
            </div>
          </div>

          <!-- Loyer -->
          <div class="col-md-4 col-sm-12">
            <div class="form-group">
              <label class="form-label fw-medium text-black">
                Loyer mensuel (FCFA) <span class="text-danger">*</span>
              </label>
              <Field name="loyer" type="number" v-model="loyer" class="form-control shadow-none fs-md-15 text-black"
                placeholder="0" step="0.01" min="0" />
              <ErrorMessage name="loyer" class="text-danger" />
            </div>
          </div>

          <!-- Solde initial -->
          <div class="col-md-4 col-sm-12">
            <div class="form-group">
              <label class="form-label fw-medium text-black">
                Solde initial (FCFA) <span class="text-danger">*</span>
              </label>
              <Field name="solde_initial" type="number" v-model="solde_initial"
                class="form-control shadow-none fs-md-15 text-black" placeholder="0" step="0.01" />
              <ErrorMessage name="solde_initial" class="text-danger" />
            </div>
          </div>

          <!-- Type de solde -->
          <div class="col-md-4 col-sm-12">
            <div class="form-group">
              <label class="form-label fw-medium text-black">
                Type de solde <span class="text-danger">*</span>
              </label>
              <Field name="type_solde" v-slot="{ field }" v-model="type_solde">
                <Multiselect :options="typeSoldeOptions" :searchable="false" v-model="field.value" v-bind="field"
                  placeholder="Sélectionner un type" />
              </Field>
              <ErrorMessage name="type_solde" class="text-danger" />
            </div>
          </div>

          <!-- Durée -->
          <div class="col-md-4 col-sm-12">
            <div class="form-group">
              <label class="form-label fw-medium text-black">
                Durée du contrat
              </label>
              <Field name="duree" type="text" v-model="duree" class="form-control shadow-none fs-md-15 text-black"
                placeholder="3 ans" />
              <ErrorMessage name="duree" class="text-danger" />
            </div>
          </div>

          <!-- Date de signature -->
          <div class="col-md-4 col-sm-12">
            <div class="form-group">
              <label class="form-label fw-medium text-black">
                Date de signature
              </label>
              <Field name="date_signature" type="date" v-model="date_signature"
                class="form-control shadow-none fs-md-15 text-black" />
              <ErrorMessage name="date_signature" class="text-danger" />
            </div>
          </div>

          <!-- Référence -->
          <div class="col-md-4 col-sm-12">
            <div class="form-group">
              <label class="form-label fw-medium text-black">
                Référence
              </label>
              <Field name="reference" type="text" v-model="reference"
                class="form-control shadow-none fs-md-15 text-black" placeholder="Référence du contrat" />
              <ErrorMessage name="reference" class="text-danger" />
            </div>
          </div>

          <!-- Motif du solde -->
          <div class="col-md-12 col-sm-12 col-xm-12 col-lg-12 ">
            <div class="form-group">
              <label class="form-label fw-medium text-black">
                Motif du solde
              </label>
              <Field name="motifsolde" type="text" v-model="motifsolde"
                class="form-control shadow-none fs-md-15 text-black" placeholder="Motif du solde initial" />
              <ErrorMessage name="motifsolde" class="text-danger" />
            </div>
          </div>

          <!-- Observation -->
          <div class="col-md-12 col-sm-12">
            <div class="form-group">
              <label class="form-label fw-medium text-black">
                Observation
              </label>
              <Field name="observation" v-model="observation" as="textarea" rows="3"
                class="form-control shadow-none fs-md-15 text-black" placeholder="Observations sur le contrat" />
              <ErrorMessage name="observation" class="text-danger" />
            </div>
          </div>

          <!-- Boutons -->
          <div class="col-md-12 mt-3">
            <div class="d-flex align-items-center">
              <button class="btn btn-success me-3" type="submit" :disabled="loading">
                <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                Créer le contrat
              </button>
              <router-link to="/liste-contrats" class="btn btn-danger">
                <i class="fa fa-times lh-1 me-1"></i>
                Annuler
              </router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as Yup from "yup";
import ApiService from "@/services/ApiService";
import { useRouter } from "vue-router";
import Multiselect from "@vueform/multiselect";
import Swal from "sweetalert2";

export default defineComponent({
  name: "AddContrat",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
  },
  setup() {
    const router = useRouter();
    const loading = ref(false);
    const codeemp = ref(null);
    const matricule = ref(null);
    const loyer = ref<number | string>(0);
    const solde_initial = ref<number | string>(0);
    const type_solde = ref("Avoir");
    const duree = ref("3 ans");
    const date_signature = ref(new Date().toISOString().split('T')[0]);
    const reference = ref("");
    const num_compte = ref("");
    const motifsolde = ref("");
    const observation = ref("");

    const typeSoldeOptions = [
      { value: "Avoir", label: "Avoir" },
      { value: "Dette", label: "Dette" },
    ];

    const contratSchema = Yup.object().shape({
      codeemp: Yup.string().required("L'emplacement est obligatoire"),
      matricule: Yup.string().required("L'usager est obligatoire"),
      loyer: Yup.number().required("Le loyer est obligatoire").min(0, "Le loyer doit être positif"),
      solde_initial: Yup.number().required("Le solde initial est obligatoire"),
      type_solde: Yup.string().required("Le type de solde est obligatoire"),
      duree: Yup.string().notRequired(),
      date_signature: Yup.date().notRequired(),
      reference: Yup.string().notRequired(),
      motifsolde: Yup.string().notRequired(),
      observation: Yup.string().notRequired(),
    });

    const fetchEmplacementOptions = async (query: string) => {
      try {
        const response = await ApiService.post("emplacements/mot", { recherche: query });
        console.log("Les emplacements sont récupérés avec succès.");
        console.log(response.data);
        if (response.data.code === 200) {
          const emplacements = response.data.data.map((emp: any) => ({
            value: emp.codeemp,
            label: `${emp.ncode_emp || emp.codeemp} - ${emp.nref_emp || ''} - [${emp.secteur?.libelle_secteur} - ${emp.secteur?.zone?.libelle_zone} - ${emp.secteur?.zone?.marche?.nomMarche}]`,
          }));
          console.log("Les emplacements sont récupérés avec succès.");
          console.log(emplacements);
          return emplacements;
        } else {
          return [];
        }
      } catch (error) {
        console.error("Erreur lors de la recherche d'emplacement:", error);
        return [];
      } 
    };

    const fetchUsagerOptions = async (query: string) => {
      try {
        const response = await ApiService.post("getUsagerByKey", { recherche: query });
        if (response.data && response.data.data) {
          return response.data.data.map((usager: any) => ({
            value: usager.matricule,
            label: `${usager.matricule} || ${usager.nom} ${usager.prenom} ${usager.tel ? " - " + usager.tel : ""}`,
          }));
        }
        return [];
      } catch (error) {
        console.error("Erreur lors de la recherche d'usager:", error);
        return [];
      }
    };

    const createContrat = async (values: any) => {
      loading.value = true;
      try {
        const contratData = {
          codeemp: codeemp.value,
          matricule: matricule.value,
          loyer: typeof loyer.value === 'string' ? parseFloat(loyer.value) : loyer.value,
          solde_initial: typeof solde_initial.value === 'string' ? parseFloat(solde_initial.value) : solde_initial.value,
          type_solde: type_solde.value,
          duree: duree.value || "3 ans",
          date_signature: date_signature.value || new Date().toISOString(),
          reference: reference.value || null,
          num_compte: num_compte.value || null,
          motifsolde: motifsolde.value || null,
          observation: observation.value || null,
          etape_validation: true,
          est_valide: true,
        };

        const response = await ApiService.post("/contrats", contratData);

        if (response.data && response.data.success) {
          await Swal.fire({
            icon: "success",
            title: "Succès",
            text: response.data.message || "Le contrat a été créé avec succès.",
            confirmButtonText: "OK",
          });
          router.push("/liste-contrats");
        } else {
          throw new Error(response.data.message || "Erreur lors de la création du contrat");
        }
      } catch (error: any) {
        console.error("Erreur lors de la création du contrat:", error);
        await Swal.fire({
          icon: "error",
          title: "Erreur",
          text: error.response?.data?.message || error.message || "Une erreur est survenue lors de la création du contrat.",
          confirmButtonText: "OK",
        });
      } finally {
        loading.value = false;
      }
    };

    return {
      loading,
      codeemp,
      matricule,
      loyer,
      solde_initial,
      type_solde,
      duree,
      date_signature,
      reference,
      num_compte,
      motifsolde,
      observation,
      typeSoldeOptions,
      contratSchema,
      fetchEmplacementOptions,
      fetchUsagerOptions,
      createContrat,
    };
  },
});
</script>

